<template>
  <div>
    <!-- <h1>{{ msg }}</h1> -->
    <!-- <img src="@/assets/maximalist-logo.svg"> -->
    <div class="center">
      <img src="@/assets/maximalist.gif">
      <!-- <div class="title">Coming Soon</div> -->
      <div>
        <a href="mailto:connect@maximalist.com" class="title">Make Contact</a>  
      </div>  
    </div>  
    <video playsinline autoplay muted loop poster="" id="bgvid">
        <source src="@/assets/maximalist-bg-medium.webm" type="video/webm">
        <source src="@/assets/maximalist-bg-medium.mp4" type="video/mp4">
    </video>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!--[if lt IE 9]>
  <script>
    document.createElement('video');
  </script>
<![endif]-->    

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  video#bgvid { 
    position: fixed;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    z-index: -100;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    background: url(../assets/static-bg.png) no-repeat;    
    background-size: cover; 
  }

  .title {
    color: #fff;
    text-transform: uppercase;
    font-size: 25px;
    margin-top: 20px;
    display: block;
    text-decoration: none;    
    letter-spacing: 1.5px;    
  }

  .center {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #fff;
    top: 50%;
    left: 50%;
    -webkit-transform: translate3d(-50%,-50%,0);
    transform: translate3d(-50%,-50%,0);
    position: absolute;    
  }

  .center img {
    width: 500px;
  }

  video { 
    display: block; 
  }

  /* Extra Small Devices, Phones */ 
  @media only screen and (max-width : 570px) {
    .center img {
      width: 100%;
    }

    .title {
      font-size: 15px;
      font-weight: bold;
    }  
  }  

</style>



// WEBPACK FOOTER //
// src/components/Home.vue